/** Strip to digits; drop a leading US country code `1` when 11 digits. */
export function phoneDigits(value: string | null | undefined): string {
  let digits = String(value ?? '').replace(/\D/g, '');
  if (digits.length === 11 && digits.startsWith('1')) {
    digits = digits.slice(1);
  }
  return digits.slice(0, 10);
}

/** Progressive US mask: `(555) 000-0000`. */
export function formatPhoneNumber(value: string | null | undefined): string {
  const digits = phoneDigits(value);
  if (digits.length === 0) {
    return '';
  }
  if (digits.length < 4) {
    return `(${digits}`;
  }
  if (digits.length < 7) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  }
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}

/** Optional field: empty is ok; partial values must be a full 10-digit number. */
export function validateOptionalPhone(
  value: string | null | undefined,
): string | undefined {
  const digits = phoneDigits(value);
  if (!digits) {
    return undefined;
  }
  if (digits.length !== 10) {
    return 'Enter a complete 10-digit phone number';
  }
  return undefined;
}
